interface TagFilterProps {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function TagFilter({ label, options, value, onChange }: TagFilterProps) {
  return (
    <div className="flex items-start gap-3 md:gap-4">
      <span className="shrink-0 pt-2 text-sm text-foreground-500 w-12">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = option === value;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(option)}
              className={`px-3 py-1.5 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer ${
                active
                  ? 'bg-primary-500 text-background-50 font-medium'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200'
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}